import { render, staticRenderFns } from "./ViewItemSectionTitle.vue?vue&type=template&id=f6417dc6"
import script from "./ViewItemSectionTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewItemSectionTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports